import { Button, Dialog, DialogActions, DialogContent } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import React from 'react';
import { useHistory } from 'react-router-dom';
import DialogTitle from 'v2/components/Shared/DialogTitle';
import { Space } from 'v2/components/Shared/Space';

export default function Zapier() {
  const history = useHistory();

  const handleClose = () => {
    const canGoBack = history.action !== 'POP';

    if (!canGoBack) {
      history.push('/producer/dashboard');

      return;
    }

    history.goBack();
  };

  return (
    <Grid container spacing={2}>
      <Dialog open={true} disableBackdropClick onClose={handleClose} scroll='body' fullWidth maxWidth='sm'>
        <DialogTitle onClose={handleClose}>
          <img height={45} src='/zapier.svg' alt='Zapier logo' />
        </DialogTitle>
        <DialogContent>
          <p>
            Agora você pode integrar sua conta da Eduzz e automatizar seu funil de vendas com mais de 5.000 aplicativos, para que você possa escalar
            fazendo o que mais sabe fazer, enquanto automatizamos o resto!
          </p>
          <br />
          <p>
            <a href='https://zapier.com' target='_blank' rel='noreferrer'>
              Conheça mais sobre essa integração
            </a>
          </p>
        </DialogContent>
        <DialogActions>
          <a href='https://ajuda.eduzz.com/hc/pt-br/articles/11780815400859-Como-integrar-utilizando-o-Zapier-' target='_blank' rel='noreferrer'>
            Veja nosso FAQ
          </a>
          <Space axis='horizontal' size={8} />
          <a href='https://zapier.com/apps/eduzz/integrations' target='_blank' rel='noreferrer'>
            <Button variant='contained' color='primary'>
              Integrar agora
            </Button>
          </a>
        </DialogActions>
      </Dialog>
    </Grid>
  );
}
